const DealerPortalMenuProductTypeEnumValue = {
  InventoryItem: 'InventoryItem',
  Tooling: 'Tooling',
  PanelType: 'PanelType',
  ExteriorSignage: 'ExteriorSignage',
  MerchandisingProgram: 'MerchandisingProgram',
  UsefulLink: 'usefulLink',
};

const DealerPortalMenuProductTypeEnum = [
  {
    value: DealerPortalMenuProductTypeEnumValue.InventoryItem,
  },
  {
    value: DealerPortalMenuProductTypeEnumValue.Tooling,
  },
  {
    value: DealerPortalMenuProductTypeEnumValue.PanelType,
  },
  {
    value: DealerPortalMenuProductTypeEnumValue.ExteriorSignage,
  },
  {
    value: DealerPortalMenuProductTypeEnumValue.MerchandisingProgram,
  },
  {
    value: DealerPortalMenuProductTypeEnumValue.UsefulLink,
  },
];

export default DealerPortalMenuProductTypeEnum;
export { DealerPortalMenuProductTypeEnumValue };
